import * as React from "react";
import { ArrowRightIcon, Text } from "evergreen-ui";
export const SelMaterial = ({ selMaterial, fontSize, seperator = React.createElement(ArrowRightIcon, null), }) => {
    if (!selMaterial)
        return React.createElement(React.Fragment, null);
    return (React.createElement(Text, { fontSize: fontSize },
        selMaterial.Mgroup,
        seperator,
        selMaterial.SubGroup,
        React.createElement("br", null),
        seperator,
        " ",
        selMaterial.Caption,
        " ",
        seperator,
        selMaterial.Thickness + "mm"));
};
